/*LIBRARY*/
import { useContext } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import { Draggable } from "../reuseable"; // Import Draggable
import ADD_PARENT_BI from "./ADD_PARENT_BI";
import BI_FOLDER_LIST from "./BI_FOLDER_LIST";
import BI_EDIT_CSS from "./BI_EDIT_CSS";

/*REDUX*/
import { set_value_bi } from "../../App/actions/biActions";

/*PICTURE*/
import ICON_PLUS from "../../Assets/jsx/ICON_PLUS";

/*FUNCTION*/
import get_url_query from "../../App/validation/get_url_query";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const BI_SIDEBAR_LIST = ({ bi, link, set_value_bi }) => {
  const { handleError } = useContext(ErrorContext);

  // Destructure bi state
  const {
    bi_object,
    modal_add_parent,
    modal_edit_css,
    folder_id_open_list,
    folder_list,
  } = bi;

  const toggle_edit_css = () => {
    handleError(() => {
      set_value_bi({
        key: "modal_edit_css",
        value: !modal_edit_css,
      });
    })();
  };

  const toggle_add_parent = () => {
    handleError(() => {
      set_value_bi({
        key: "modal_add_parent",
        value: !modal_add_parent,
      });
    })();
  };

  const on_open_all_folder = () => {
    handleError(() => {
      if (folder_id_open_list?.length === 0) {
        const folder_id_open_list_value = folder_list?.map((item) => item._id);
        set_value_bi({
          key: "folder_id_open_list",
          value: folder_id_open_list_value,
        });
      } else {
        set_value_bi({
          key: "folder_id_open_list",
          value: [],
        });
      }
    })();
  };

  //local storage
  const language = localStorage?.language || "ina";
  const mode = get_url_query("mode");

  // Content for Add Parent Modal
  const modal_add_parent_content = modal_add_parent && (
    <Modal
      modalSize="large"
      isOpen={modal_add_parent}
      onClose={toggle_add_parent}
      backgroundColor="rgb(235, 235, 235)"
    >
      <div className="box-body" id="box-body">
        <main className="max_height">
          <ADD_PARENT_BI />
        </main>
      </div>
    </Modal>
  );

  // Content for Draggable CSS Editor
  const draggable_edit_css_content = modal_edit_css && (
    <Draggable
      title="Edit CSS"
      toggle_close={toggle_edit_css}
      style={{
        background: "white",
        width: "350px",
        zIndex: 10,
        maxHeight: "calc( 100vh - 100px )",
        overflow: "auto",
      }}
      initialPosition={{
        x: 20,
        y: 20,
      }}
    >
      <div style={{ padding: "10px" }}>
        <BI_EDIT_CSS />
      </div>
    </Draggable>
  );

  return (
    <main className="bi_sidebar_left_parent">
      {modal_add_parent_content}
      {draggable_edit_css_content}

      <section className="bi_sidebar_left_non_scroll">
        <Link
          className="badge_pill background_orange margin_bottom margin_right"
          to="/dashboard?menu=bi"
        >
          {dict?.["Back"]?.[language]}
        </Link>
        <table className="full_width">
          <tbody>
            <tr>
              <td></td>
              <td className="text_right">
                {mode === "edit" && (
                  <button
                    className={`badge_pill outline_black margin_bottom margin_right ${
                      modal_edit_css
                        ? "background_black text_white"
                        : "background_white"
                    }`}
                    onClick={toggle_edit_css}
                  >
                    css
                  </button>
                )}
                <Link
                  className={`badge_pill outline_black margin_bottom margin_right ${
                    mode !== "edit"
                      ? "background_black text_white"
                      : "background_white"
                  }`}
                  to={`/bi/${link}`}
                >
                  View
                </Link>
                <Link
                  className={`badge_pill outline_black margin_bottom margin_right  ${
                    mode === "edit"
                      ? "background_black text_white"
                      : "background_white"
                  }`}
                  to={`/bi/${link}?mode=edit`}
                >
                  Edit
                </Link>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1 className="text_header margin_bottom max_two_lines_big">
          {bi_object?.name || dict?.["BI OVERVIEW DASBOARD"]?.[language]}
        </h1>
        {mode === "edit" && (
          <>
            <br />
            <button
              onClick={toggle_add_parent}
              className="button_pill background_white margin_bottom margin_right"
              data-mapid="clickAddProject"
            >
              <span className="badge_circle background_green margin_right">
                <ICON_PLUS />
              </span>
              {dict?.["Add project/folder"]?.[language]}
            </button>
          </>
        )}

        <br />
        <button
          className="button_small margin_bottom background_black"
          onClick={on_open_all_folder}
        >
          {dict?.["Open/close all folders"]?.[language]}
        </button>
        <br />
      </section>
      <BI_FOLDER_LIST toggle_add_parent={toggle_add_parent} />
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  bi: state.bi,
});

export default connect(mapStateToProps, { set_value_bi })(BI_SIDEBAR_LIST);
